import {useEffect} from "react";
import {Card, CardHeader, CardContent, Typography} from "@mui/material";

import {useTranslation} from "react-i18next";

import {useLocation, useSearchParams} from "wouter";

import {authClient} from "./App.jsx";

const Done = () => {
    const {t} = useTranslation();

    const [, setLocation] = useLocation();

    const [searchParams, setSearchParams] = useSearchParams();
    const session = searchParams.get("session");

    useEffect(() => {
        const processSession = async () => {
            await authClient.stripe.process({sessionId: session});
            setLocation("/");
            }

        if (session) {
            processSession();
            }
        }, [session]);
    return (
        <Card>
            <CardHeader title={t("Thank you")} />
            <CardContent>
                <Typography>{t("Done")}</Typography>
            </CardContent>
        </Card>
        );
    }

export default Done;